export default __webpack_public_path__ + "assets/upload-gallery-image.095e60cd.png";